import axios from "axios";
const api = axios.create({
  baseURL: import.meta.env.PUBLIC_LIVE_LINK, //import.meta.env.PUBLIC_STORE_DOMAIN
});
// commit
export default {
  // createOrder: async (payload) => {
  //     return await api.post("/admin/api/2022-10/orders.json", JSON.stringify(payload), {
  //         headers: {
  //             'Content-Type': 'application/json',
  //             // 'X-Shopify-Access-Token': process.env.REACT_APP_PUBLIC_STORE_API_KEY
  //         }
  //     })
  // },
  // sendOrderToStore: async (payload) => {
  //     return await axios.post('/checkout', JSON.stringify(payload))
  // },
  orderCreation: async (payload) => {
    return await api.post("/create-order", JSON.stringify(payload), {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  sendWarranty: async (payload) => {
    return await api.post("/send-warranty", JSON.stringify(payload), {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  sendContact: async (payload) => {
    return await api.post("/contact-form", JSON.stringify(payload), {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
};
